import React from "react";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import Image from "../components/Image";

export const richTextOptions = {
  renderNode: {
    [INLINES.EMBEDDED_ENTRY]: (node, children) => {
      const typename = node?.data?.target?.__typename;

      if (typename === "ContentfulImage") {
        return <Image props={node.data.target} />;
      }
    },
  },
  renderText: (text) => {
    return text.split("\n").reduce((children, textSegment, index) => {
      return [...children, index > 0 && <br key={index} />, textSegment];
    }, []);
  },
};
